import React from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';

const MAX_RATING = 5;

const StarList = styled.span`
  display: inline-flex;
  align-items: center;
  line-height: 1;
  > i {
    font-size: 0.9075rem;
    margin-right: 0.2475rem;
    color: #b0bec5;
  }
  > i:last-child {
    margin-right: 0;
  }
  > i.star--filled {
    color: #263238;
  }
`;

const StarRating = ({ value, className }) => {
  const filled = Math.max(0, Math.min(MAX_RATING, Math.round(Number(value) || 0)));
  return (
    <StarList
      className={className}
      role="img"
      aria-label={`${filled} out of ${MAX_RATING} stars`}
    >
      {Array.from({ length: MAX_RATING }, (item, index) => (
        <i
          key={index}
          aria-hidden="true"
          className={index < filled ? 'fa fa-star star--filled' : 'fa fa-star'}
        />
      ))}
    </StarList>
  );
};

export default StarRating;

StarRating.propTypes = {
  value: propTypes.oneOfType([propTypes.number, propTypes.string]),
  className: propTypes.string
};

StarRating.defaultProps = {
  value: 0
};
